<template>
  <loader-wrapper>
    <styled-spinner-svg />
  </loader-wrapper>
</template>

<script>
import styled from 'vue-styled-components';
import SpinnerSvg from '@/components/svg/Spinner';

const loaderWrapper = styled.section`
  width: 100%;
  height: 100%;
  height: calc(100% - 46px);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background-color: var(--secondary_background_color);
`;
const styledSpinnerSvg = styled(SpinnerSvg)``;

export default {
  components: {
    loaderWrapper,
    styledSpinnerSvg,
  },
};
</script>

<style></style>
